// This component has been added ad-hoc by sales-leader-insights-fe team: https://private.hubteam.com/janus/groups/hs-sales-leader-insights-fe
// For any questions/concerns, please use Slack channel: #sales-leader-insights-fe

import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const TranscriptSettingTooltipHeaderText = ({
  isTranscriptionAdmin
}) => isTranscriptionAdmin ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "transcriptQuickFilter.transcriptSettingPlaceholder.adminTooltip.header"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "transcriptQuickFilter.transcriptSettingPlaceholder.nonAdminTooltip.header"
});